<template>
    <div class="stats-container">
        <h1 class="stats-title">统计分析</h1>
        <p class="stats-intro">这里将展示各项关键性能指标的统计数据和分析结果。</p>
        <div class="stats-content">
            <!-- 图表或数据内容将在这里插入 -->
            <p class="placeholder-text">...</p>
        </div>
    </div>
</template>

<script>
    import {axios} from "../../config/axios";
    export default {
        name: "home-page",
        data () {
            return {
                editableTabsValue: '2',
                editableTabs: [{
                    title: 'Tab 1',
                    name: '1',
                    status: 'Active'
                }, {
                    title: 'Tab 2',
                    name: '2',
                    status: 'Active'
                }],
                tabIndex: 2,
                currentComponent: 'VehicleStat',
            }
        },
        watch: {

        },
        computed:{
            uploadFile:function () {
                return this.baseURL+"person/search-face"
            }
        },
        created: function () {
        },
        methods:{
            addTab(targetName) {
                let newTabName = ++this.tabIndex + '';
                this.editableTabs.push({
                    title: 'New Tab',
                    name: newTabName,
                    content: 'New Tab content'
                });
                this.editableTabsValue = newTabName;
            },
            removeTab(targetName) {
                let tabs = this.editableTabs;
                let activeName = this.editableTabsValue;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                activeName = nextTab.name;
                            }
                        }
                    });
                }

                this.editableTabsValue = activeName;
                this.editableTabs = tabs.filter(tab => tab.name !== targetName);
            }

        }
    }
</script>
<style>
    .stats-container {
        font-family: 'Arial', sans-serif; /* 使用通用的无衬线字体 */
        margin: 20px;
        padding: 20px;
        background-color: #f8f9fa; /* 浅灰色背景 */
        border-radius: 8px; /* 轻微的边角圆滑 */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 轻微的阴影提升层次感 */
    }

    .stats-title {
        color: #333; /* 深灰色文字 */
        margin-bottom: 10px;
    }

    .stats-intro {
        color: #666; /* 中等灰色文字 */
        margin-bottom: 20px;
    }

    .stats-content {
        padding: 20px;
        background-color: #fff; /* 白色背景提升内容区域的对比 */
        border: 1px solid #e1e1e1; /* 浅灰色边框 */
        border-radius: 5px; /* 内容区域边角圆滑 */
    }

    .placeholder-text {
        text-align: center;
        color: #bbb; /* 浅灰色文字 */
    }
</style>
